<template>
  <div
    :class="{
      [$style.wrapper]: true,
      [$style.selected]: selected,
      [$style.clickable]: clickable,
      [$style.disabled]: disabled
    }"
    :role="chipRole"
    :tabindex="chipTabIndex"
    @click="emitClick"
    @keydown.enter="emitClick"
    @keydown.space="emitClick"
  >
    <slot v-if="hasCount" name="count">
      <div :class="$style.count">{{ count }}</div>
    </slot>
    <slot v-if="$slots.body" name="body"></slot>
    <p>{{ text }}</p>
    <slot v-if="defaultAction || $slots.action" name="action">
      <div
        aria-label="remove"
        role="button"
        :class="$style.defaultAction"
        tabindex="0"
        @click.stop="remove"
        @keyup.space.stop="remove"
        @keyup.enter.stop="remove"
      >
        <FontAwesomeIcon
          :icon="faTimes"
        />
      </div>
    </slot>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'

// TODO - Copied verbatim from Marmot Vue3. Once the job board uses Marmot Vue3 then
// we can delete this and use the latest chip component from there instead.

export default {
  // NewChip to replace current Chip once we have updated existing chips to tags in BitJobs
  name: 'NewChip',
  components: {
    FontAwesomeIcon,
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: null
    },
    defaultAction: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: true,
    },
    // Event handler for click is passed as this prop, when using @click
    // No other way to check if @click is registered
    onClick: {
      type: Function,
      default: undefined,
    },
  },
  emits: ['remove', 'click'],
  computed: {
    faTimes() {
      return faTimes
    },
    hasCount() {
      return this.count != null;
    },
    clickable() {
      return this.onClick !== undefined
    },
    chipTabIndex() {
      return this.clickable ? "0" : undefined
    },
    chipRole() {
      return this.clickable ? "button" : undefined
    },
  },
  methods: {
    remove() {
      if (this.disabled) {
        return
      }
      this.$emit('remove')
    },
    emitClick(...args) {
      // Don't check 'clickable', as clickable is only true when an
      // @click handler is registered.
      this.$emit('click', ...args)
    },
  }
}
</script>



<style module src="./NewChip.css" />
